export default {
    writeCache: (key, content) => {
        cache[key] = content;
    },
    readCache: (key) => {
        return cache[key];
    }
}

const cache = {};